import { Button, Stack, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AntSwitch } from "../../../user-management/user-management-list/components/ant-switch";
import "./dashboard-sub-header-section.scss";
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit-outline.svg";
interface DashboardSubHeaderSectionInterface {
  isOpen: boolean;
  editMode: boolean;
  isSaveDisabled: boolean;
  setIsOpen: () => void;
  onEditMode: () => void;
  saveWidget: () => void;
  onCancelEdit: () => void;
}

const DashboardSubHeaderSection: React.FC<
  DashboardSubHeaderSectionInterface
> = ({
  isOpen,
  editMode,
  isSaveDisabled,
  setIsOpen,
  onEditMode,
  onCancelEdit,
  saveWidget,
}) => {
  const labelSwitch = { inputProps: { "aria-label": "Switch demo" } };
  return (
    <div className="sub-header-section">
      <Typography className="dashboard-sub-title">My CRM Overview</Typography>
      <div className="sub-header-right-section">
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <Typography className="expand-text">Collapse</Typography>

          <AntSwitch
            {...labelSwitch}
            defaultChecked={false}
            checked={isOpen}
            onChange={(e) => {
              setIsOpen();
            }}
          />
          <Typography className="expand-text">Expand</Typography>
        </Stack>
        {!editMode && (
          <Tooltip title="Edit Widgets">
          <EditIcon
            className="header-edit-icon"
            onClick={() => {
              onEditMode();
            }}
          />
          </Tooltip>
        )}

        {editMode && (
          <div>
            <Button
              className="cancel-button sub-header-action-button"
              variant="outlined"
              onClick={() => {
                onCancelEdit();
              }}
            >
              Cancel
            </Button>
            <Button
              className="save-button sub-header-action-button"
              variant="contained"
              disabled={isSaveDisabled}
              onClick={() => {
                saveWidget();
              }}
            >
              Save
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default DashboardSubHeaderSection;
